import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import "../styles/global.css";
import "../styles/about.css";
import { Helmet } from "react-helmet";
const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "About Us";
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);

    // Initialize AdSense
    try {
      if (window.adsbygoogle && process.env.NODE_ENV !== "development") {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  // const teamMembers = [
  //   {
  //     name: "Dr. Emily Chen",
  //     role: "Relationship Psychologist",
  //     image: "assets/images/team-emily.jpeg",
  //     bio: "Dr. Chen specializes in relationship dynamics with over 15 years of clinical experience helping couples navigate complex challenges.",
  //   },
  //   {
  //     name: "Marcus Johnson",
  //     role: "Research Director",
  //     image: "assets/images/team-marcus.jpeg",
  //     bio: "Marcus leads our research initiatives, ensuring all assessments and resources are based on the latest psychological findings.",
  //   },
  //   {
  //     name: "Sophia Williams",
  //     role: "Content Strategist",
  //     image: "assets/images/team-sophia.jpeg",
  //     bio: "Sophia transforms complex relationship concepts into accessible, practical advice for our users.",
  //   },
  // ];

  return (
    <div className="about-container">
      <Header />
      <Helmet>
        <title>About us</title>
        <meta
          name="description"
          content="About us, who developed the content of this website"
        />
      </Helmet>
      <section className="about-hero">
        <div className="about-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            About Relationship Wellness
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lead-text">
            We're on a mission to help people make informed decisions about
            their relationships through evidence-based assessments and
            resources.
          </motion.p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}>
                Our Story
              </motion.h2>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}>
                Relationship Wellness was founded in 2021 by a team of
                relationship psychologists and therapists who recognized a
                critical need: people often struggle to objectively evaluate
                their relationships and make decisions that serve their
                wellbeing.
              </motion.p>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}>
                After years of clinical practice, our founders observed that
                many individuals remain in unfulfilling or unhealthy
                relationships due to emotional attachment, fear of change, or
                simply because they lack a structured framework to assess their
                situation.
              </motion.p>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}>
                Our assessment tool was developed through rigorous research and
                testing, combining established psychological principles with
                practical insights from thousands of relationship journeys.
                We're committed to providing a judgment-free space where
                individuals can gain clarity about their relationship's health
                and potential.
              </motion.p>
            </div>

            <div className="about-image">
              <motion.img
                src="assets/images/about-mission.jpeg"
                alt="Our mission"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Top Ad Placement */}
      <div className="container">
        <div className="ad-container about-top-ad">
          {/* <div className="ad-label">Advertisement</div> */}
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-2067522743161930"
            data-ad-slot="1234567890"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
        </div>
      </div>

      <section className="about-approach">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>
            Our Approach
          </motion.h2>

          <div className="approach-grid">
            <motion.div
              className="approach-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}>
              <div className="approach-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Evidence-Based</h3>
              <p>
                Our assessment is grounded in psychological research and
                validated relationship studies, not personal opinions or trends.
              </p>
            </motion.div>

            <motion.div
              className="approach-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}>
              <div className="approach-icon">
                <i className="fas fa-balance-scale"></i>
              </div>
              <h3>Balanced Perspective</h3>
              <p>
                We present unbiased insights that consider both the strengths
                and challenges of your unique relationship situation.
              </p>
            </motion.div>

            <motion.div
              className="approach-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}>
              <div className="approach-icon">
                <i className="fas fa-lock"></i>
              </div>
              <h3>Confidential</h3>
              <p>
                Your privacy matters. All assessment responses are confidential,
                and we don't store personally identifiable information.
              </p>
            </motion.div>

            <motion.div
              className="approach-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}>
              <div className="approach-icon">
                <i className="fas fa-hand-holding-heart"></i>
              </div>
              <h3>Compassionate</h3>
              <p>
                We recognize that relationship decisions are deeply personal.
                Our guidance comes from a place of empathy and support.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
{/* 
      <section className="about-team">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>
            Meet Our Team
          </motion.h2>

          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                className="team-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * index }}>
                <div className="team-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <div className="team-role">{member.role}</div>
                  <p>{member.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Bottom Ad Placement */}
      <div className="container">
        <div className="ad-container about-bottom-ad">
          {/* <div className="ad-label">Advertisement</div> */}
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-2067522743161930"
            data-ad-slot="1234567891"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
        </div>
      </div>

      <section className="about-values">
        <div className="container">
          <div className="about-grid reverse">
            <div className="about-content">
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}>
                Our Values
              </motion.h2>

              <motion.div
                className="values-list"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}>
                <div className="value-item">
                  <div className="value-title">
                    <i className="fas fa-star"></i>
                    <h3>Empowerment Through Information</h3>
                  </div>
                  <p>
                    We believe that knowledge and self-awareness lead to better
                    decisions and healthier relationships.
                  </p>
                </div>

                <div className="value-item">
                  <div className="value-title">
                    <i className="fas fa-heart"></i>
                    <h3>Personal Growth</h3>
                  </div>
                  <p>
                    Relationships should foster, not hinder, each person's
                    development and wellbeing.
                  </p>
                </div>

                <div className="value-item">
                  <div className="value-title">
                    <i className="fas fa-users"></i>
                    <h3>Community Support</h3>
                  </div>
                  <p>
                    No one should navigate relationship challenges alone. We're
                    building a supportive community of shared experiences.
                  </p>
                </div>

                <div className="value-item">
                  <div className="value-title">
                    <i className="fas fa-compass"></i>
                    <h3>Honesty & Integrity</h3>
                  </div>
                  <p>
                    We're committed to providing truthful guidance, even when
                    truths are difficult to confront.
                  </p>
                </div>
              </motion.div>
            </div>

            <div className="about-image">
              <motion.img
                src="assets/images/about-values.jpeg"
                alt="Our values"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <motion.div
            className="cta-box"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>
            <h2>Ready to gain clarity?</h2>
            <p style={{color:"#FFF"}}>
              Take our research-backed relationship assessment and receive
              personalized insights.
            </p>
            <motion.a
              href="/quiz"
              className="cta-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}>
              Start Assessment
              <i className="fas fa-arrow-right"></i>
            </motion.a>
          </motion.div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3 style={{color:"#FFF"}}>Relationship Wellness</h3>
              <p style={{color:"#FFF"}}>Evidence-based insights for healthier relationships.</p>
              <div className="social-icons">
                <a href="#" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
            <div className="footer-links">
              <h4 style={{color:"#FFF"}}>Quick Links</h4>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About Us</a>
                </li>
                <li>
                  <a href="/blog">Blog</a>
                </li>
                <li>
                  <a href="/resources">Resources</a>
                </li>
                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-contact">
              <h4 style={{color:"#FFF"}}>Contact Us</h4>
              <p>
                <i className="fas fa-envelope"></i> support@nivexa.net
              </p>
              {/* <p><i className="fas fa-phone"></i> (555) 123-4567</p> */}
              <p>
                <i className="fas fa-map-marker-alt"></i> 123 Wellness Ave,
                Suite 200
                <br />
                San Francisco, CA 94110
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="copyright">
              © {new Date().getFullYear()} Relationship Wellness. All rights
              reserved.
            </p>
            <div className="legal-links">
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Use</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;
